module.exports = __webpack_public_path__ + "img/reg-3.584e553f.jpg";